import Helper from '@lovata/popup-helper';

export default new class headerAccount {
  constructor() {
    this.drawerBtnSelector = 'js-header-account';
    this.panelSelector = 'header-account-info__panel';
    this.panelOpenSelector = 'header-account-info__panel_visible';
    this.drawerParentSelector = 'header';
    this.drawerCloseSelector = 'header-account-mini-panel__close';

    this.drawerNavSelector = 'drawer-nav';
    this.drawerOpenNavSelector = 'drawer-nav_open';
    this.drawerWrapperSelector = 'drawer-nav__wrapper';
    this.hiddenSelector = 'drawer-nav__wrapper_hidden';

    this.loginFormSelector = 'login-modal__form';
    this.submitBtnSelector = 'login-modal__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'login-modal__success';
    this.successVisibleSelector = 'login-modal__success_visible';
    this.preLoaderSelector = 'login-modal__preloader';

    this.init();
  }

  init() {
    this.load();
  }

  load() {
    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.panelSelector);
    body.append(div);

    $.request('onAjax', {
      update: {
        'users/header-account/header-account-mini': `.${this.panelSelector}`,
      },
      complete: () => {
        this.handler();
        this.initForm();
      },
    });
  }

  handler() {
    $(document)
      .on('click', `.${this.drawerBtnSelector}`, () => {
        this.togglePopup();
      });
  }

  initForm() {
    const form = document.querySelector(`.${this.loginFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    const isValid = !form.classList.contains(this.inValidSelector);

    if (!isValid) return;

    $(form)
      .request('EokLogin::onAjax', {
        loading: `.${this.preLoaderSelector}`,
        complete: (res) => {
          this.closeForm(res);
          this.showTooltip(res);
        },
      });
  }

  closeForm(res) {
    const { responseJSON } = res;

    if (!responseJSON.status) return;

    this.togglePopup();
    window.location.reload();
  }

  togglePopup() {
    const panel = $(`.${this.panelSelector}`);
    const isOpen = panel.hasClass(this.panelOpenSelector);
    const closeBtnNode = document.querySelector(`.${this.drawerCloseSelector}`);

    Helper.setBodyScrollState(isOpen);
    Helper.overlayController(!isOpen);

    panel.toggleClass(this.panelOpenSelector);
    Helper.overlayHandler(!isOpen, closeBtnNode, panel[0]);

    setTimeout(() => {
      Helper.focusTrapManager(!isOpen, panel[0]);
    }, 300);
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
